import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/templates/Page.jsx";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Tip = makeShortcode("Tip");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`I created my first website in the age of floppy disks. `}<a parentName="p" {...{
        "href": "http://joecartoon.com/"
      }}>{`Flash`}</a>{` and `}<a parentName="p" {...{
        "href": "http://ps2.praystation.com/pound/v3/"
      }}>{`ActionScript`}</a>{` proved me that web may be really fun. I have been devoted to the frontend development for many years and currently being working mainly with `}<a parentName="p" {...{
        "href": "https://reactjs.org/"
      }}>{`React`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.typescriptlang.org/"
      }}>{`TypeScript`}</a>{`. I also use tools like `}<a parentName="p" {...{
        "href": "https://laravel.com/"
      }}>{`Laravel`}</a>{`, `}<a parentName="p" {...{
        "href": "https://nette.org/"
      }}>{`Nette`}</a>{` or `}<a parentName="p" {...{
        "href": "https://wordpress.org/"
      }}>{`WordPress`}</a>{` to solve things on the backend side. Furthermore, I'm experienced in `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/ABAP"
      }}>{`ABAP`}</a>{` development in `}<a parentName="p" {...{
        "href": "http://go.sap.com/"
      }}>{`SAP`}</a>{` systems.`}</p>
    <p>{`My interest is in the open source, static sites, continuous integration, security and decentralized applications.`}</p>
    <Tip mdxType="Tip">
      <p>{`You can check `}<a parentName="p" {...{
          "href": "/now"
        }}>{`what I'm doing now`}</a>{`, or see my `}<a parentName="p" {...{
          "href": "/cv"
        }}>{`CV`}</a>{`.`}</p>
    </Tip>
    <p>{`I love science fiction, either as a film or a book. My body is tormented during run or in a gym regularly. Walks in the nature, more-day hiking as well as camping are something I cannot live without. I like to learn new things and often deal with the smallest details to make something great. I come from the beautiful city of Kosice, Slovakia.`}</p>
    <p>{`From time-to-time I express my thoughts in non-technical way and `}<a parentName="p" {...{
        "href": "https://dennikn.sk/autor/iafke/"
      }}>{`write in my native language`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      